export default "__VITE_ASSET__b161d81e__"